'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _set = require('lodash/set');var _set2 = _interopRequireDefault(_set);
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var cleanUpPropertyTypes = function cleanUpPropertyTypes(types) {
  if (typeof types === 'string') {
    return [types];
  }

  var cleared = types.filter(function (type) {return type !== 'all';});

  return cleared.length ? cleared : undefined;
};

// const getCountry = (address) => get(address, 'en.country_name');
// const getCity = (address) => get(address, 'en.city_name');

var getCountry = function getCountry(address) {return (0, _get2.default)(address, 'en.country_name');};
var getCity = function getCity(address) {
  var city = (0, _get2.default)(address, 'en.city_name');
  if (city && city === 'Moscow') return 'Moskva';
  if (city && city.includes('Petersburg')) return 'Peterburg';
  return city;
};

var getCurrency = function getCurrency(value) {
  var currency = typeof value === 'string' ? value : (0, _get2.default)(value, 'value', '');
  return currency.toUpperCase();
};

var getOptionType = function getOptionType(value) {
  if (value === 'commercial' || value === 'projects') {
    return 'buy';
  }
  return value;
};

var keyMap = [
['address', 'country', getCountry],
['address', 'city', getCity],
['option_type', 'option', getOptionType],
['property_types', 'type', cleanUpPropertyTypes],
['min_price', 'min', _clearNumber2.default],
['max_price', 'max', _clearNumber2.default],
['currency', 'currency', getCurrency]];


var formatValuesForRequest = function formatValuesForRequest(values) {
  var params = {};
  keyMap.forEach(function (_ref) {var clientPath = _ref[0],serverPath = _ref[1],formatter = _ref[2];
    var value = (0, _get2.default)(values, clientPath);
    if (!value) {return;}

    if (formatter) {value = formatter(value);}
    (0, _set2.default)(params, serverPath, value);
  });

  return params;
};exports.default =

formatValuesForRequest;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignSearchContainer/helpers.js
// module id = 2912
// module chunks = 0